export default "__VITE_ASSET__D6O1y62X__"